export enum Gender {
    MALE = 'M',
    FEMALE = 'F',
    OTHER = '9'
}